'use client';

import { useState } from 'react';
import { X, Sparkles } from 'lucide-react';
import { useTranslations } from 'next-intl';

import { Link } from '@/core/i18n/navigation';
import { cn } from '@/shared/lib/utils';

export function AnnouncementBanner() {
  const [isVisible, setIsVisible] = useState(true);
  const t = useTranslations('common.announcement');

  if (!isVisible) return null;

  return (
    <div className="relative z-[60] w-full overflow-hidden bg-gradient-to-r from-purple-600 via-pink-600 to-purple-700 text-white shadow-lg">
      <div className="container mx-auto flex items-center justify-between gap-4 px-4 py-3 sm:px-6">
        {/* Icon + Message */}
        <Link
          href="/ai-art-generator"
          className="flex flex-1 cursor-pointer items-center justify-center gap-2 text-center transition-transform hover:scale-[1.02]"
        >
          <Sparkles className="h-5 w-5 flex-shrink-0 animate-pulse" />
          <span className="text-sm font-semibold sm:text-base">
            {t('new_model')}
          </span>
          <Sparkles className="hidden h-5 w-5 flex-shrink-0 animate-pulse sm:block" />
        </Link>

        {/* Close Button */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            setIsVisible(false);
          }}
          className={cn(
            'flex-shrink-0 rounded-full p-1 transition-colors',
            'hover:bg-white/20'
          )}
          aria-label="Close announcement"
        >
          <X className="h-4 w-4" />
        </button>
      </div>

      {/* Animated gradient overlay for extra visual appeal */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer" />
    </div>
  );
}

